module.exports = __webpack_public_path__ + "img/RIREKI_STAMPMARK.007c2e79.png";